(function () {
    'use strict';

    angular
        .module('app')
        .controller('ContractsController', ContractsController);

    ContractsController.$inject = ['$state',];

    function ContractsController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'contracts') {
                $state.go('contracts.list');
            }
        }
    }
})();